let ctx;
let introPlayed = false;

export function getAudioContext() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = ctx || new AC();
    return ctx;
  } catch {
    return null;
  }
}

export function playChime(volume = 0.14, force = false) {
  try {
    if (localStorage.getItem("cs-sound") === "off") return false;
    if (introPlayed && !force) return false;
    const ac = getAudioContext();
    if (!ac || ac.state !== "running") return false;

    const now = ac.currentTime + 0.02;
    const master = ac.createGain();
    master.gain.value = volume;
    const lp = ac.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 3400;
    master.connect(lp);
    lp.connect(ac.destination);

    const bell = (freq, delay, peak, decay) => {
      const o = ac.createOscillator();
      o.type = "sine";
      o.frequency.value = freq;
      const g = ac.createGain();
      const t = now + delay;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(peak, t + 0.025);
      g.gain.exponentialRampToValueAtTime(0.0001, t + decay);
      o.connect(g);
      g.connect(master);
      o.start(t);
      o.stop(t + decay + 0.1);
    };

    bell(164.81, 0, 0.35, 2.6);     // E3 warmth
    bell(659.25, 0, 1.0, 2.4);      // E5
    bell(987.77, 0.13, 0.7, 2.2);   // B5
    bell(1318.51, 0.27, 0.45, 2.0); // E6 shimmer
    introPlayed = true;
    return true;
  } catch {
    return false;
  }
}

export function playSuccess(volume = 0.12) {
  try {
    if (localStorage.getItem("cs-sound") === "off") return false;
    const ac = getAudioContext();
    if (!ac || ac.state !== "running") return false;
    const now = ac.currentTime + 0.02;
    const master = ac.createGain();
    master.gain.value = volume;
    const lp = ac.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 3200;
    master.connect(lp);
    lp.connect(ac.destination);

    const note = (freq, delay, peak, decay) => {
      const o = ac.createOscillator();
      o.type = "sine";
      o.frequency.value = freq;
      const g = ac.createGain();
      const t = now + delay;
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(peak, t + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, t + decay);
      o.connect(g);
      g.connect(master);
      o.start(t);
      o.stop(t + decay + 0.1);
    };

    note(523.25, 0, 1.0, 1.1);    // C5
    note(783.99, 0.16, 0.9, 1.4); // G5 — resolved, "filed"
    return true;
  } catch {
    return false;
  }
}

export function playTick(volume = 0.05) {
  try {
    if (localStorage.getItem("cs-sound") === "off") return false;
    const ac = getAudioContext();
    if (!ac) return false;
    if (ac.state === "suspended") {
      ac.resume();
      return false;
    }
    const t = ac.currentTime;
    const o = ac.createOscillator();
    o.type = "triangle";
    o.frequency.setValueAtTime(2400, t);
    o.frequency.exponentialRampToValueAtTime(1700, t + 0.05);
    const g = ac.createGain();
    g.gain.setValueAtTime(volume, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.07);
    const lp = ac.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 5200;
    o.connect(g);
    g.connect(lp);
    lp.connect(ac.destination);
    o.start(t);
    o.stop(t + 0.09);
    return true;
  } catch {
    return false;
  }
}
